(function() {
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days || 7) * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/';
  }

  // Mark body when a setting has been selected — used by sp-diamond-buy-loose-fix
  if (getCookie('_ring')) {
    document.documentElement.classList.add('sp-has-ring');
    if (document.body) document.body.classList.add('sp-has-ring');
    document.addEventListener('DOMContentLoaded', function() {
      document.body.classList.add('sp-has-ring');
    });
  }

  // Behavior #1 — "Choose a diamond" step → go to selected stone
  function interceptStepClick(e) {
    var node = e.target, stepContainer = null;
    while (node && node !== document.body) {
      if (node.classList && node.classList.contains('step-container')) {
        stepContainer = node;
        break;
      }
      node = node.parentNode;
    }
    if (!stepContainer) return;
    var stepParent = stepContainer.parentNode;
    if (!stepParent || stepParent.getAttribute('data-step') !== 'diamonds') return;
    var raw = getCookie('_diamonmd');
    if (!raw) return;
    var diamond = null;
    try { diamond = JSON.parse(raw); } catch (err) { return; }
    if (!diamond || !diamond.sku) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/products/diamonds?sku=' + encodeURIComponent(diamond.sku) + '';
  }
  document.addEventListener('click', interceptStepClick, true);

  // Behavior #3 — NO-LOOP GUARANTEE on Add to Ring
  // Monitor only — never preventDefault/stopProp on the click that triggered us.
  var addBtnBusy = false;
  function getAddToRingButton(el) {
    if (!el) return null;
    if (el.id === 'addtoring') return el;
    if (el.closest) return el.closest('#addtoring');
    return null;
  }
  function onAddToRing(e) {
    var btn = getAddToRingButton(e.target);
    if (!btn) return;
    if (addBtnBusy) return;
    addBtnBusy = true;
    setTimeout(function(){ addBtnBusy = false; }, 1500);
    var ringRawBefore = getCookie('_ring');
    if (!ringRawBefore) return;
    var ringData = null;
    try { ringData = JSON.parse(ringRawBefore); } catch(err) { return; }
    if (!ringData || !ringData.handle) return;
    var start = Date.now();
    var restored = false;
    var poll = setInterval(function(){
      var cur = getCookie('_ring');
      if (!cur && !restored) {
        setCookie('_ring', ringRawBefore, 7);
        restored = true;
      }
      if (Date.now() - start > 2000) {
        clearInterval(poll);
        if (restored && /\/collections\/engagement-rings/.test(window.location.pathname + window.location.search)) {
          var dRaw = getCookie('_diamonmd');
          if (dRaw) {
            try {
              var d = JSON.parse(dRaw);
              if (d && d.sku) {
                var url = ringData.handle;
                if (url.indexOf('/products/') !== 0) url = '/products/' + url;
                url += '?variant=' + encodeURIComponent(ringData.vid || '') +
                       '&view=final-ring&diamond=' + encodeURIComponent(d.sku);
                window.location.replace(url);
              }
            } catch(e){}
          }
        }
      }
    }, 40);
  }
  document.addEventListener('click', onAddToRing, true);
})();
